const sconf = (window as any).$sk.config;
export class Piwik {
  constructor(
    private tenantId: string | number,
    private siteId: string | number
  ) {
    if (sconf.matomoUrl) {
      this.setPiwik();
    }
  }

  setPiwik() {
    if (!(window as any)._paq) {
      (window as any)._paq = [];
    }
    (window as any)._paq.push(["trackPageView"]);
    (window as any)._paq.push(["enableLinkTracking"]);
    (window as any)._paq.push([
      "setTrackerUrl",
      sconf.matomoUrl + "matomo.php",
    ]);
    (window as any)._paq.push(["setSiteId", this.siteId]);
    const d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];
    g.type = "text/javascript";
    g.async = true;
    g.defer = true;
    g.src = sconf.matomoUrl + "matomo.js";
    s.parentNode.insertBefore(g, s);

    this.resetPiwik();

    if (this.tenantId == "949") {
      // const _hmt = (window as any)._hmt || [];
      if (!(window as any)._hmt) {
        (window as any)._hmt = [];
      }
      (function () {
        const hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?c9a04a03ec6e1530687e948ade6d5074";
        hm.async = true;
        document.head.appendChild(hm);
      })();
    }
  }

  resetPiwik() {
    if ((window as any).Piwik) {
      const piwikTracker = (window as any).Piwik.getTracker();
      piwikTracker.setSiteId(2000);
      piwikTracker.setTrackerUrl(sconf.matomoUrl + "matomo.php");
      piwikTracker.trackPageView();
    } else {
      setTimeout(() => {
        this.resetPiwik();
      }, 500);
    }
  }
}
